import type { OptIn, ShipiumOauthClient, CreateOauthClientResponse, ShipiumApiKey } from './types';

export const mockedApiKeys: ShipiumApiKey[] = [
  {
    active: true,
    apiKey: 'key123',
    apiKeyId: 'key_id_123',
    createdBy: 'Marquis Mark',
    creationTimeStamp: '2021-03-09T01:54:28.678Z',
    lastUpdatedBy: 'Marquis Mark',
    lastUpdatedTimeStamp: '2021-03-09T01:54:28.678Z',
    metadata: {
      additionalProp1: 'string',
      additionalProp2: 'string',
      additionalProp3: 'string',
    },
    name: 'Dev Api Key',
  },
];
export const mockedOptIns: OptIn[] = [
  {
    optInId: 'exceptions-management-opt-in',
    name: 'Exceptions Management',
    description: 'Partners assigned this opt in will have exceptions generated and have the ability to manage them.',
    commonAuthorities: ['FULFILLMENT_EXCEPTION_API'],
    adminAuthorities: ['PARTNER_ADMIN', 'PARTNER_EDITOR', 'PARTNER_VIEWER'],
    editAuthorities: ['PARTNER_EDITOR', 'PARTNER_VIEWER'],
    viewAuthorities: ['PARTNER_VIEWER'],
    associatedPartners: [],
    active: true,
  },
  {
    optInId: 'reporting-opt-in',
    name: 'Delivery Experience Reporting',
    description:
      'Partners assigned this opt in will have access to their delivery experience performance through the reporting-service endpoints.',
    commonAuthorities: ['REPORTING_API'],
    adminAuthorities: ['PARTNER_ADMIN', 'PARTNER_EDITOR', 'PARTNER_VIEWER'],
    editAuthorities: ['PARTNER_EDITOR', 'PARTNER_VIEWER'],
    viewAuthorities: ['PARTNER_VIEWER'],
    associatedPartners: ['90cdf3cc-d308-4e6e-acd3-20c5586dc808'],
    active: true,
  },
  {
    optInId: 'subscriptions-opt-in',
    name: 'Subscriptions',
    description: 'Partners assigned this opt in will have access subscription endpoints in the shiptime-service.',
    commonAuthorities: ['SUBSCRIPTION_API'],
    adminAuthorities: ['PARTNER_ADMIN', 'PARTNER_EDITOR', 'PARTNER_VIEWER'],
    editAuthorities: ['PARTNER_EDITOR', 'PARTNER_VIEWER'],
    viewAuthorities: ['PARTNER_VIEWER'],
    associatedPartners: ['b2c5ff44-4b4f-4d57-8415-e11a30c37a04'],
    active: true,
  },
  {
    optInId: 'delivery-experience-opt-in',
    name: 'Delivery Experience',
    description:
      'Partners assigned this opt in will have access to the product/order/ship/delivery delivery experience endpoints in the shiptime-service.',
    commonAuthorities: ['DELIVERY_EXPERIENCE_API'],
    adminAuthorities: ['PARTNER_ADMIN', 'PARTNER_EDITOR', 'PARTNER_VIEWER'],
    editAuthorities: ['PARTNER_EDITOR', 'PARTNER_VIEWER'],
    viewAuthorities: ['PARTNER_VIEWER'],
    associatedPartners: ['90cdf3cc-d308-4e6e-acd3-20c5586dc808'],
    active: true,
  },
  {
    optInId: 'tracking-info-request-opt-in',
    name: 'Tracking Info Request',
    description:
      'Partners assigned this opt in will have access to the carrier tracking information request endpoints in the shiptime-service.',
    commonAuthorities: ['TRACKING_INFO_REQUEST'],
    adminAuthorities: ['PARTNER_ADMIN', 'PARTNER_EDITOR', 'PARTNER_VIEWER'],
    editAuthorities: ['PARTNER_EDITOR', 'PARTNER_VIEWER'],
    viewAuthorities: ['PARTNER_VIEWER'],
    associatedPartners: [],
    active: true,
  },
];

export const mockedPartnerOptIns: OptIn[] = [
  {
    optInId: 'exceptions-management-opt-in',
    name: 'Exceptions Management',
    description: 'Partners assigned this opt in will have exceptions generated and have the ability to manage them.',
    commonAuthorities: ['FULFILLMENT_EXCEPTION_API'],
    adminAuthorities: ['PARTNER_ADMIN', 'PARTNER_EDITOR', 'PARTNER_VIEWER'],
    editAuthorities: ['PARTNER_EDITOR', 'PARTNER_VIEWER'],
    viewAuthorities: ['PARTNER_VIEWER'],
    associatedPartners: [],
    active: true,
  },
  {
    optInId: 'reporting-opt-in',
    name: 'Delivery Experience Reporting',
    description:
      'Partners assigned this opt in will have access to their delivery experience performance through the reporting-service endpoints.',
    commonAuthorities: ['REPORTING_API'],
    adminAuthorities: ['PARTNER_ADMIN', 'PARTNER_EDITOR', 'PARTNER_VIEWER'],
    editAuthorities: ['PARTNER_EDITOR', 'PARTNER_VIEWER'],
    viewAuthorities: ['PARTNER_VIEWER'],
    associatedPartners: ['90cdf3cc-d308-4e6e-acd3-20c5586dc808'],
    active: true,
  },

  {
    optInId: 'delivery-experience-opt-in',
    name: 'Delivery Experience',
    description:
      'Partners assigned this opt in will have access to the product/order/ship/delivery delivery experience endpoints in the shiptime-service.',
    commonAuthorities: ['DELIVERY_EXPERIENCE_API'],

    adminAuthorities: ['PARTNER_ADMIN', 'PARTNER_EDITOR', 'PARTNER_VIEWER'],
    editAuthorities: ['PARTNER_EDITOR', 'PARTNER_VIEWER'],
    viewAuthorities: ['PARTNER_VIEWER'],
    associatedPartners: ['90cdf3cc-d308-4e6e-acd3-20c5586dc808'],
    active: true,
  },
  {
    optInId: 'tracking-info-request-opt-in',
    name: 'Tracking Info Request',
    description:
      'Partners assigned this opt in will have access to the carrier tracking information request endpoints in the shiptime-service.',

    commonAuthorities: ['TRACKING_INFO_REQUEST'],
    adminAuthorities: ['PARTNER_ADMIN', 'PARTNER_EDITOR', 'PARTNER_VIEWER'],
    editAuthorities: ['PARTNER_EDITOR', 'PARTNER_VIEWER'],
    viewAuthorities: ['PARTNER_VIEWER'],
    associatedPartners: [],
    active: true,
  },
  {
    optInId: 'carrier-selection-opt-in',
    name: 'Carrier Selection',
    description:
      'Partners assigned this opt in will have access to the carrier tracking information request endpoints in the shiptime-service.',

    commonAuthorities: ['TRACKING_INFO_REQUEST'],
    adminAuthorities: ['PARTNER_ADMIN', 'PARTNER_EDITOR', 'PARTNER_VIEWER'],
    editAuthorities: ['PARTNER_EDITOR', 'PARTNER_VIEWER'],
    viewAuthorities: ['PARTNER_VIEWER'],
    associatedPartners: [],
    active: true,
  },
  {
    optInId: 'package-sizing-opt-in',
    name: 'Tracking Info Request',
    description:
      'Partners assigned this opt in will have access to the carrier tracking information request endpoints in the shiptime-service.',

    commonAuthorities: ['TRACKING_INFO_REQUEST'],
    adminAuthorities: ['PARTNER_ADMIN', 'PARTNER_EDITOR', 'PARTNER_VIEWER'],
    editAuthorities: ['PARTNER_EDITOR', 'PARTNER_VIEWER'],
    viewAuthorities: ['PARTNER_VIEWER'],
    associatedPartners: [],
    active: true,
  },
  {
    optInId: 'shipping-label-retrieval-opt-in',
    name: 'Tracking Info Request',
    description:
      'Partners assigned this opt in will have access to the carrier tracking information request endpoints in the shiptime-service.',

    commonAuthorities: ['TRACKING_INFO_REQUEST'],
    adminAuthorities: ['PARTNER_ADMIN', 'PARTNER_EDITOR', 'PARTNER_VIEWER'],
    editAuthorities: ['PARTNER_EDITOR', 'PARTNER_VIEWER'],
    viewAuthorities: ['PARTNER_VIEWER'],
    associatedPartners: [],
    active: true,
  },
];

export const mockedAuthorities = [
  {
    authority: 'AUTHENTICATED_USER',
    description: 'Base level authority given to a user / client that is authenticated via OAuth.',
  },
  {
    authority: 'DELIVERY_EXPERIENCE_API',
    description: 'Grants access to all the delivery experience endpoints in the shiptime-service.',
  },
  {
    authority: 'INTERNAL_OAUTH_ADMIN',
    description: 'Authorization to manage OAuth client, roles, and authorities.',
  },
  {
    authority: 'INTERNAL_PARTNER_SEARCH',
    description:
      'Given to authenticated OAuth users with the ability to search across all partners.  Only available to internal admin users.',
  },
  {
    authority: 'INTERNAL_PARTNER_USER_ADMIN',
    description:
      'Given to internal OAuth users and clients allowing linking of users to any partner.  Generally used upon creation of a new partner such that the initial user may me linked to the partner.',
  },
  {
    authority: 'INTERNAL_REPORT_GENERATION',
    description:
      'Given to internal OAuth users and clients and used to aggregate partner data and get it ready for viewing on the partner report screens.',
  },
  {
    authority: 'PARTNER_ADMIN',
    description:
      'Given to authenticated OAuth users having full authority to manage a partner including linking and unlinking users.',
  },
  {
    authority: 'PARTNER_EDITOR',
    description: 'Given to authenticated OAuth users having read and limited write authority to manage a partner.',
  },
  {
    authority: 'PARTNER_OPT_INS_VIEWER',
    description:
      'Authority given to OAuth clients / users needing insight into what partners have opted into what functionality.',
  },
  {
    authority: 'PARTNER_VIEWER',
    description: 'Given to authenticated OAuth users having read only authority to manage a partner.',
  },
  {
    authority: 'FULFILLMENT_EXCEPTION_API',
    description:
      'Given to authenticated OAuth clients and users that have access to the exceptions endpoints for a partner.',
  },
  {
    authority: 'FULFILLMENT_EXCEPTION_BULK_CREATE',
    description:
      'Given to authenticated internal OAuth clients and users that have access to the exceptions endpoints for a partner.',
  },
  {
    authority: 'MANAGE_PARTNER_OPT_INS',
    description:
      'Internal authority given to OAuth clients and users who have the ability to add/create/maintain optIn definitions, as well as link up partners to functionality they pay for.',
  },
  {
    authority: 'REPORTING_API',
    description: "Grants access to all the reporting endpoints in the reporting-service segmented on a partner's data.",
  },
  {
    authority: 'SIMULATE_DEID_BACKFILLS',
    description: "Given to internal accounts allowed to push 'simulated' data into the delivery experience endpoints.",
  },
  {
    authority: 'SUBSCRIPTION_API',
    description:
      "Grants access to all the subscription endpoints in the shiptime-service segmented on a partner's data.",
  },
  {
    authority: 'TRACKING_INFO_REQUEST',
    description: 'Grants access to all the tracking info endpoints in the shiptime-service.',
  },
];

export const mockedOauthClients: ShipiumOauthClient[] = [
  {
    oauthClientId: 'X654OE3U3HNSOET7DMX7',
    name: 'Partner_key',
    authorities: ['PARTNER_ADMIN', 'PARTNER_EDITOR', 'PARTNER_VIEWER'],
    grantTypes: ['client_credentials'],
    scopes: ['auth-service', 'shiptime-service'],
    active: true,
    metadata: {
      partnerId: '465de651-5d16-4d8f-a2e7-3dbb3eed2b20',
      type: 'partner',
    },
    creationTimeStamp: '2020-07-09T21:55:00.881Z',
    lastUpdatedTimeStamp: '2020-07-09T22:00:40.25Z',
  },
  {
    oauthClientId: '1234OE3U3HNSOET7DMX7',
    name: 'Partner_inactive_key',
    authorities: ['PARTNER_ADMIN', 'PARTNER_EDITOR', 'PARTNER_VIEWER'],
    grantTypes: ['client_credentials'],
    scopes: ['auth-service', 'shiptime-service'],
    active: false,
    metadata: {
      partnerId: '465de651-5d16-4d8f-a2e7-3dbb3eed2b20',
      type: 'partner',
    },
    creationTimeStamp: '2020-09-09T21:55:00.881Z',
    lastUpdatedTimeStamp: '2020-09-09T22:00:40.25Z',
  },
];

export const newOauthClientRes: CreateOauthClientResponse = {
  oauthClient: {
    oauthClientId: '1223XWKNWKQWNQW8981Z',
    name: 'new_Partner_key',
    authorities: ['PARTNER_ADMIN', 'PARTNER_EDITOR', 'PARTNER_VIEWER'],
    grantTypes: ['client_credentials'],
    scopes: ['auth-service', 'shiptime-service'],
    active: true,
    metadata: {
      partnerId: '465de651-5d16-4d8f-a2e7-3dbb3eed2b20',
      type: 'partner',
    },
    creationTimeStamp: '2020-07-09T21:55:00.881Z',
    lastUpdatedTimeStamp: '2020-07-09T22:00:40.25Z',
  },
  oauthClientSecret: 'shhhimasecret123',
};
